import {CUSTOMER_TYPE_ALLOW} from '../config/const';
import {getConfigValue} from '../reducers/configReducer';
import {hasID, hasRec} from '../reducers/userReducer';
import customerType from '../const/customer_type';

/**
 * Validate user before checkout
 * @returns {function(*,*): boolean} - true if user isn't valid
 */
export const validateUserDocs = () => (dispatch, getState) => {
  const state = getState();
  const user = state.user;
  const customerTypeAllowed = getConfigValue(CUSTOMER_TYPE_ALLOW, state);
  const isRec = hasRec(state);
  const hasId = hasID(state);
  const userAdult = user.customerType === customerType.ADULT;

  let disabledNoDocs = true;

  if (userAdult) {
    disabledNoDocs = false;
  }
  else {
    disabledNoDocs = !isRec;
  }

  return disabledNoDocs || !hasId;
};



// WEBPACK FOOTER //
// ./src/actions/user.js